<template>
<v-container class="pa-0 pb-12">
	<v-row class="px-3 fill-height scroll-wrapper" ref="row">
		<v-col
			cols="12"
			md="12" class="pa-0">
			<v-card color="#000" width="100%" class="mx-auto" rounded="0">
				<v-card-title class="tabel-header">
				{{$t('text.competitions')}} - {{$t('text.regMan')}}
				</v-card-title>
				<v-card-text class="pa-0">
					<div v-for="(e, i) in Competitions" @click="openCompetitionDetails(e.id)" class="f-row data-row pl-1" :class="{ 'zebra-dark': (i%2), 'zebra-light': !(i%2)}" :key="i">
						<div class="f-row date">
							<div class="day">{{ e.date | moment('DD') }}</div>
							<div>
								<div>{{ e.date | moment('MMM') }}</div>
								<div>{{ e.date | moment('YYYY') }}</div>
							</div>
						</div>
						<div class="pl-3 data">
							<div>{{ e.name }}</div>
							<div>{{ e.location }}</div>
						</div>
					</div>
					<div v-if="Competitions.length === 0" class="no-data">{{$t('text.noDataText')}}</div>
				</v-card-text>
			</v-card>
			<spinner :loading="loading"></spinner>
		</v-col>
	</v-row>
	<v-row><v-col cols="12" sm="4">
		<c-button
			:disabled="loading"
			@click="scan"
			:label="$t(`text.scanRegMan`)"
			class="w-100">
		</c-button>
	</v-col></v-row>
</v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import digiRegmanActions from '../store/actions/digiRegman';
import namespace from '../store/namespace';
import Spinner from '../general/Spinner.vue';

import CButton from '../globalComponents/CButton.vue';


import modelState from '../mixins/modelState';

export default {
	name: 'Competitions',
	mixins: [modelState],
	components: {
		Spinner,
		CButton,
	},
	data() {
		return {
			loading: true,
			headers: [
				{
					text: '',
					value: 'date',
				},
			],
		};
	},
	async mounted() {
		await this.loadData();
		this.$refs.row.style.height = `${this.WindowSize.y - 170}px`;
	},
	watch: {
		'WindowSize.y': function () {
			this.$refs.row.style.height = `${this.WindowSize.y - 170}px`;
		},
	},
	computed: {
		...mapGetters(['WindowSize']),
		...mapGetters(namespace.DIGIREGMAN, ['Links', 'Competitions']),
	},
	methods: {
		...mapActions(namespace.DIGIREGMAN, [
			digiRegmanActions.GET_DIGI_REG_LINKS,
			digiRegmanActions.ADD_COMPETITOR,
			digiRegmanActions.GET_COMPETITIONS]),
		async loadData() {
			this.loading = true;
			try {
				await this.GET_DIGI_REG_LINKS();
				if (this.$route.params && this.$route.params.cId) {
					const data = await this.ADD_COMPETITOR(this.$route.params.cId);
					this.$router.push({ name: 'competitiondetail', params: { cId: data.competition_Id } });
				}
				await this.GET_COMPETITIONS();
			} finally {
				this.loading = false;
			}
		},
		openCompetitionDetails(id) {
			this.$router.push({ name: 'competitiondetail', params: { cId: id } });
		},
		scan() {
			this.$router.push({ name: 'qr' });
		},
	},
};
</script>

<style lang="scss" scoped>

@import "../globalComponents/style/_globals";

.tabel-header {
	color: $seltec_color;
	height: 40px;
	padding:5px 10px;
	overflow: auto hidden;
	white-space: nowrap;
}

.data-row {
	color: $font-light-color;
	cursor: pointer;
}

.scroll-wrapper {
	overflow: hidden auto;
}

.zebra-dark {
	background-color: $zebra-dark;
}

.zebra-light {
	background-color: $zebra-light;
}

.no-data {
	color:$font-light-color;
	background-color:$sec_color_dark;
	text-align: center;
}

.date {
	font-weight: bold;
	.day {
		line-height: 44px;
		font-size: 44px;
		padding-right: 5px;
	}
}

.data {
	div {
		width: 100%;
		overflow: hidden;
		text-overflow: '...';
		height: 22px;
	}
}
</style>
